<template>
  <div
    class="d-flex"
  >
    <v-checkbox
      v-model="isAgree"
      class="mt-0 pt-0"
      color="primary"
      hide-details
    />
    <div class="text-body-2 text--text">
      {{ t('Регистрируясь на сайте, вы даете согласие на', options) }}
      <a
        href="/info/privacy-policy/"
        target="_blank"
        class="text-decoration-none primary--text d-inline"
      >{{ t('обработку персональных данных', options) }}</a>
      {{ t('и принимаете', options) }}
      <a
        href="/info/terms-of-use/"
        target="_blank"
        class="text-decoration-none primary--text d-inline"
      >{{ t('пользовательское соглашение', options) }}</a>.
    </div>
  </div>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'
import { computed } from 'vue'

const props = defineProps<{
  value: boolean
}>()

type Emits = {
  (_event: 'input', _value: boolean): void
}

const emit = defineEmits<Emits>()

const isAgree = computed({
  get() {
    return props.value
  },
  set(value: boolean) {
    emit('input', value)
  },
})

const { t, language } = I18NextVue
const options = { ns: language }
</script>
